import { Instruction } from '../internal.js';
/**
 * Unknown Instruction.
 */
export class UnknownInstruction extends Instruction {
    argsBuf;
    constructor(opcode, argsBuf) {
        super(opcode);
        this.argsBuf = argsBuf;
    }
}
